import React from "react";
import { Box, Typography } from "@mui/material";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { TriedFresh } from "@/helpers/enums";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
  dogName: string;
  value?: string | null;
  onChange: (value: TriedFresh) => void;
};

const OPTIONS: ChoiceOption[] = [
  { value: TriedFresh.YES, label: "Yes", emoji: "👍" },
  { value: TriedFresh.NO, label: "No", emoji: "👎" },
];

function reassurance(value: string | null | undefined, dogName: string): string | null {
  if (value === TriedFresh.YES) {
    return "Then you already know the difference fresh makes. We think we make even better fresh food, and often at a lower price too.";
  }
  if (value === TriedFresh.NO) {
    return `You're in for a treat. Fresh is a big step up from the bowl ${dogName || "your dog"}'s used to, and we make switching easy.`;
  }
  return null;
}

/** Issue #52 A2 — shown only when the dog isn't already on fresh food. */
export function TriedFreshQuestion({ dogName, value, onChange }: Props) {
  const line = reassurance(value, dogName);

  return (
    <QuestionCard
      title={`Has ${dogName || "your dog"} ever tried fresh food before?`}
    >
      <QuizChoiceCard
        options={OPTIONS}
        selected={value ?? ""}
        onSelect={(v) => onChange(v as TriedFresh)}
      />

      {line && (
        <Box
          sx={{
            mt: 2,
            mx: "auto",
            maxWidth: 420,
            bgcolor: QUIZ.color.cream2,
            borderRadius: "12px",
            px: "16px",
            py: "12px",
          }}
        >
          <Typography
            sx={{
              fontFamily: QUIZ.font.body,
              fontSize: { xs: 14, md: 15 },
              color: QUIZ.color.ink,
              lineHeight: 1.45,
            }}
          >
            {line}
          </Typography>
        </Box>
      )}
    </QuestionCard>
  );
}
